import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { useHome } from "@/context/HomeContent";
import { mediaUrl } from "@/lib/api";
import { fadeUp, staggerParent, viewportOnce } from "@/lib/animations";

const BrandIntro = () => {
  const { home } = useHome();
  const d = home.brand;
  return (
    <section id="story" data-testid="brand-intro-section" className="relative bg-brand-cream py-24 sm:py-32">
      <div className="mx-auto grid max-w-[1400px] grid-cols-1 items-center gap-12 px-5 sm:px-8 lg:grid-cols-[0.9fr_1.1fr] lg:gap-20">
        <motion.div variants={staggerParent} initial="hidden" whileInView="show" viewport={viewportOnce} className="relative">
          <motion.div variants={fadeUp} className="relative h-[380px] overflow-hidden rounded-[28px] border border-brand-line sm:h-[500px]">
            <img src={mediaUrl(d.image)} alt="Nupur Pittie speaking" className="h-full w-full object-cover object-top" />
          </motion.div>
          <motion.div variants={fadeUp} custom={1} className="absolute -bottom-8 -right-4 hidden h-44 w-56 overflow-hidden rounded-2xl border-4 border-brand-cream shadow-xl sm:block">
            <img src={mediaUrl(d.image2)} alt="Recognised across industry" className="h-full w-full object-cover" />
          </motion.div>
          <motion.div variants={fadeUp} custom={2} className="absolute -left-4 top-8 hidden rounded-2xl border border-brand-line bg-white/90 px-5 py-4 backdrop-blur sm:block">
            <p className="brand-gradient-text font-heading text-3xl font-bold">{d.statValue}</p>
            <p className="font-body text-xs text-brand-ink/60">{d.statLabel}</p>
          </motion.div>
        </motion.div>

        <motion.div variants={staggerParent} initial="hidden" whileInView="show" viewport={viewportOnce}>
          <motion.p variants={fadeUp} className="mb-5 font-heading text-xs font-bold uppercase tracking-[0.22em] text-brand-magenta">{d.eyebrow}</motion.p>
          <motion.h2 variants={fadeUp} className="max-w-xl font-heading text-4xl font-semibold leading-tight tracking-tight text-brand-ink sm:text-5xl lg:text-[3.4rem]">
            {d.headingLead}{" "}
            <span className="brand-gradient-text">{d.headingAccent}</span>
          </motion.h2>
          <motion.p variants={fadeUp} className="mt-7 max-w-xl font-body text-base leading-relaxed text-brand-ink/70 sm:text-lg">{d.body}</motion.p>
          <motion.div variants={fadeUp} className="mt-9">
            <a href="#solutions" data-testid="brand-intro-cta" className="group inline-flex items-center gap-2 border-b-2 border-brand-ink pb-1 font-heading text-base font-semibold text-brand-ink transition-colors duration-300 hover:border-brand-magenta hover:text-brand-magenta">
              {d.cta}
              <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
            </a>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default BrandIntro;
